import { useFela } from 'react-fela';
import { ButtonChevron } from '@bridebook/ui';
import styles from './carousel-controls.style';
import { FC } from 'react';

interface CarouselControlsProps {
  onPrev: () => void;
  prevDisabled: boolean;
  onNext: () => void;
  nextDisabled: boolean;
}

const CarouselControls: FC<CarouselControlsProps> = ({
  onPrev,
  prevDisabled,
  onNext,
  nextDisabled,
}) => {
  const { css } = useFela();
  return (
    <div className={css(styles.root)}>
      <ButtonChevron
        style={styles.button}
        rounded
        w={38}
        h={38}
        iconWidth={13}
        onClick={onPrev}
        disabled={prevDisabled}
        direction="left"
      />
      <ButtonChevron
        style={styles.button}
        rounded
        w={38}
        h={38}
        iconWidth={13}
        onClick={onNext}
        disabled={nextDisabled}
        direction="right"
      />
    </div>
  );
};

export default CarouselControls;
